import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import { Button, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";

import { useStoreDispatch, useStoreSelector } from "../../../../../hooks/StoreHooks";
import { getCurrentUser } from "../../../../core/common_functions";
import { usePergolaConfigurationBuilderActions } from "../../../../../store/reducers/pergola_configuration_builder";
import { useConfigurationsServicePergola } from "../../../../services/pergola_service";
import LigthChoices from "./illuminazione/ligths_choice";
import { FarettoType, LatoIlluminazioneFaretto } from "../../../../models/pergola_configuration";

export const IlluminationPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const cg = useConfigurationsServicePergola();
  const { base, pergolaConfigurationBuilder } = useStoreSelector(store => store);
  const dispatcher = useStoreDispatch();
  const currentUser = getCurrentUser(base);
  
  const { 
    setStepActive, 
    setStepComplete, 
    setFaretti,       // <-- action per salvare i faretti
    resetFaretti 
  } = usePergolaConfigurationBuilderActions();

  const [isSubmit, setSubmit] = useState(false);

  const initialValues = {
    farettoTipo: pergolaConfigurationBuilder.faretti.tipo ?? FarettoType.nessuno,
    farettoNumero: pergolaConfigurationBuilder.faretti.numero ?? 0,
  };

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    onSubmit: () => {},
  });
  useEffect(() => {
    const tipo = formik.values.farettoTipo as FarettoType;
    const numero = Number(formik.values.farettoNumero) || 0;

    const payload: LatoIlluminazioneFaretto = {
      tipo,
      numero: tipo === FarettoType.nessuno ? 0 : numero,
    };

    dispatcher(setFaretti(payload));
  }, [formik.values.farettoTipo, formik.values.farettoNumero, dispatcher, setFaretti]);

  useEffect(() => {
    if (!id || isNaN(Number(id)) || !pergolaConfigurationBuilder.configuration) {
      navigate("/configurations");
    } else {
      dispatcher(setStepActive({ stepSlug: "illuminazioni", isActive: true }));
    }
  }, [id, navigate, dispatcher, pergolaConfigurationBuilder.configuration, setStepActive]);

  const submit = async () => {
    setSubmit(true);
    const data = { ledAttive: pergolaConfigurationBuilder.led , faretti: pergolaConfigurationBuilder.faretti};
    try {
      if (pergolaConfigurationBuilder.configuration) {
        await cg.updateIlluminazine(
          currentUser,
          pergolaConfigurationBuilder.configuration.configurationId,
          data
        );
      }
      dispatcher(setStepComplete({ stepSlug: "illuminazioni", isComplete: true }));
      dispatcher(setStepActive({ stepSlug: "fioriere", isActive: true }));
      navigate(`/pergola-configurations/${id}/fioriere`);
    } catch (e: any) {
      alert(`Errore: ${e?.message || e}`);
    } finally {
      setSubmit(false);
    }
  };

  return (
    <div className="row h-full m-0">
      <div className="p-4">
        <h5 className="text-primary">Illuminazione Faretti</h5>

        <FormControl fullWidth className="mt-2">
          <InputLabel id="faretto-tipo-label">Tipo Faretto LED</InputLabel>
          <Select
            labelId="faretto-tipo-label"
            name="farettoTipo"
            label="Tipo Faretto LED"
            value={formik.values.farettoTipo}
            onChange={formik.handleChange}
          >
            <MenuItem value={FarettoType.faretto_freddo}>Luce fredda</MenuItem>
            <MenuItem value={FarettoType.faretto_caldo}>Luce calda</MenuItem>
            <MenuItem value={FarettoType.nessuno}>Nessun faretto</MenuItem>
          </Select>
        </FormControl>

        {formik.values.farettoTipo !== FarettoType.nessuno && (
          <TextField
            fullWidth
            label="Numero di faretti"
            name="farettoNumero"
            type="number"
            margin="normal"
            inputProps={{ min: 1, step: 1 }}
            value={formik.values.farettoNumero}
            onChange={formik.handleChange}
          />
        )}

        <h5 className="text-primary mt-4">Illuminazione LED</h5>
        <LigthChoices />

        <div className="d-flex flex-row-reverse justify-content-between mt-4">
          <Button
            disabled={isSubmit}
            variant="contained"
            onClick={submit}
          >
            <span>Avanti</span>
            <NavigateNextIcon />
          </Button>

          <Button
            variant="contained"
            color="secondary"
            onClick={() => {
              dispatcher(setStepActive({ stepSlug: "chiusure", isActive: true }));
              navigate(`/pergola-configurations/${pergolaConfigurationBuilder.configuration?.configurationId}/chiusure`);
            }}
          >
            <NavigateBeforeIcon />
            <span>Indietro</span>
          </Button>
        </div>
      </div>
    </div>
  );
};